import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class RoleAuthorisationService {

  constructor(
    private _authService: AuthService
  ) {
  }

  isAuthorised(roles: string[]): boolean {

    if(roles.length === 0) return true;

    const currentRoles = this._authService.getRoles();

    // check if any of the current logged in user is in the array
    for (const role of currentRoles) {
      if (roles.includes(role)) return true;
    }

    return false;
  }
}
